export default __webpack_public_path__ + "static/image3-da038f01d766ae1d6495633b0b586fbc.jpg";